import { render, staticRenderFns } from "./TournamentDaysCard.vue?vue&type=template&id=4bd54f9a&"
import script from "./TournamentDaysCard.vue?vue&type=script&lang=js&"
export * from "./TournamentDaysCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports